import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Button } from "@masterteam/mt-design-react";
import uniqBy from "lodash/uniqBy";

import AdminPage from "../../AdminPage";
import TreeItem from "./TreeItem";
import DeleteModal from "../../DeleteModal";
import Search from "../../AdminSearch";

import api from "../../../providers/api";
import {
  addToast,
  SearchTree,
  recursiveList,
  recursiveParent,
} from "../../../helpers";

import "./style.scss";

class Tree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      users: [],
      selectedEntity: null,
      loading: true,
      usersLoading: true,
      showDeleteModal: false,
      isUpdatingTree: false,
      isEditMode: false,
      isAddMode: false,
      isDeletingEntity: false,
      usersLoading: false,
      isFilterloading: false,
      searchedFilter: "",
      Text: "",
    };
    this.rootNodeId = "node0";
    this.entityActions = {
      add: "add",
      addRoot: "addRoot",
      edit: "edit",
      delete: "delete",
    };
  }

  getAllUsers() {
    api.user
      .getAll()
      .then((res) => {
        this.setState({ users: res.Data || [], usersLoading: false });
      })
      .catch((error) => {
        this.setState({ usersLoading: false });
        addToast.error(error.message, {
          toastId: "get-users-error",
        });
      });
  }

  getAllFunctions(withLoader = true) {
    if (withLoader) this.setState({ loading: true });
    api.orgStructure
      .getAll()
      .then((res) => {
        const { StatusCode, Data } = res;
        // const { dispatch } = this.props;
        if (StatusCode === 401) {
          // logout(dispatch);
        }
        if (StatusCode === "Success") {
          this.setState({ originData: Data }, () => {
            //sorting entitites by ParentID
            Data.sort(function (a, b) {
              var nameA = a.ParentID;
              var nameB = b.ParentID;
              if (nameA < nameB) {
                return -1;
              } else if (nameA > nameB) {
                return 1;
              } else return 0;
            });
            this.setState({ data: Data, loading: false }, () => {
              this.drawTree();
              this.setTreeSpacing();
            });
          });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        addToast.error(error.message, {
          toastId: "get-functions-error",
        });
      });
  }

  isDragAllowed(target, dragged) {
    return dragged.querySelector(`#${target.id}`);
  }

  getElementData = (id) => {
    const { data } = this.state;
    return data.filter((item) => `node${item.ID}` === id)[0];
  };

  //identifying droppable item when cursor moves over the area of drop
  dragEnterHandler = (e) => {
    e.preventDefault();
    let isTreeItem = e.target.className === "tree-item";
    let element = isTreeItem ? e.target : e.target.closest(".tree-item");
    element.className = "tree-item drag-over";
  };

  dragHandler = (e) => {
    e.stopPropagation();
    e.dataTransfer.setData("text", e.target.id);
  };

  dragLeaveHandler = (e) => {
    let isTreeItem = e.target.className === "tree-item";
    let element = isTreeItem ? e.target : e.target.closest(".tree-item");
    element.className = "tree-item";
  };

  dropHandler = (e) => {
    const { data } = this.state;

    e.preventDefault();
    e.stopPropagation();

    let isTreeItem = e.target.className === "tree-item";
    let targetElement = isTreeItem ? e.target : e.target.closest(".tree-item");
    let draggedElement = document.getElementById(
      e.dataTransfer.getData("text")
    );

    //make sure dragged item is not parent of droppable item
    let isParent = !!draggedElement.querySelector(`#${targetElement.id}`);

    //handling moving item if it's not dropped on it self or on one of it's children
    if (
      !isParent &&
      +targetElement?.getAttribute("level-id") + 1 ===
        +draggedElement?.getAttribute("level-id") &&
      draggedElement.id !== targetElement.id &&
      targetElement.id !== draggedElement.parentNode.id
    ) {
      //this will fetch new parent and child elements data from state
      let _parentNodeData = this.getElementData(targetElement.id);
      let _childNodeData = this.getElementData(draggedElement.id);

      this.setState({ isUpdatingTree: true });

      //setting dragged element ParentId of new parent
      let _data = [...data];
      _data.find((item) => item.ID === _childNodeData.ID).ParentID =
        _parentNodeData ? _parentNodeData.ID : null;

      api.orgStructure
        .update(_childNodeData)
        .then((res) => {
          const { StatusCode, StatusMessage } = res;
          //  const { dispatch } = this.props;
          if (StatusCode === 401) {
            // logout(dispatch);
          }
          if (StatusCode === "Success") {
            this.setState({ data: _data, isUpdatingTree: false }, () => {
              targetElement.appendChild(draggedElement);
              this.drawTree();
              this.setTreeSpacing();
            });
          } else {
            this.setState({
              isUpdatingTree: false,
            });
            addToast.error(StatusMessage, {
              toastId: "get-functions-error",
            });
          }
        })
        .catch((error) => {
          this.setState({
            isUpdatingTree: false,
          });
          addToast.error(error.message, {
            toastId: "get-functions-error",
          });
        });
    }

    //reseting droppable styling to default after drop and setting the entity to be not draggable
    targetElement.className = "tree-item";
    draggedElement.draggable = false;
  };

  selectEntity(entity, action) {
    const { data } = this.state;

    switch (action) {
      case "delete":
        this.setState({ selectedEntity: entity, showDeleteModal: true });
        break;

      case "edit":
        let selected_entity = data.find((item) => item.ID === entity.ID);
        this.setState({
          isEditMode: true,
          selectedEntity: selected_entity,
        });
        break;

      case "add":
        this.setState({
          selectedEntity: { ID: entity.ID, LevelID: entity.LevelID },
          isAddMode: true,
        });
        break;

      case this.entityActions.addRoot:
        this.setState({
          isAddMode: true,
          selectedEntity: { ParentID: null },
        });
        break;

      default:
        break;
    }
  }

  //add new entity or root entity
  addNewEntity(_new_entity) {
    const { data } = this.state;

    this.setState({ isUpdatingTree: true });

    api.orgStructure
      .create(_new_entity)
      .then((res) => {
        const { StatusCode, Data, StatusMessage } = res;
        //   const { dispatch } = this.props;
        if (StatusCode === 401) {
          //   logout(dispatch);
        }
        if (StatusCode === "Success") {
          let _data = [...data];
          _data.push(Data);

          this.setState({
            isAddMode: false,
            selectedEntity: null,
            data: _data,
            isUpdatingTree: false,
            Text: "",
          });
          this.getAllFunctions(false);
        } else {
          addToast.error(StatusMessage, {
            toastId: "get-functions-error",
          });
          this.setState({
            isUpdatingTree: false,
            Text: "",
          });
        }
      })
      .catch((error) => {
        this.setState({
          isUpdatingTree: false,
          Text: "",
        });
        addToast.error(error.message, {
          toastId: "get-functions-error",
        });
      });
  }

  //save updated entity
  saveEntity(_updated_entity) {
    const { data } = this.state;

    this.setState({ isUpdatingTree: true });
    let _data = [...data];
    let _selectedItem = _data.find((item) => item.ID === _updated_entity.ID);
    _selectedItem.EnglishName = _updated_entity.EnglishName;
    _selectedItem.ArabicName = _updated_entity.ArabicName;
    _selectedItem.ManagerModel = _updated_entity.ManagerModel;

    api.orgStructure
      .update(_selectedItem)
      .then((res) => {
        const { StatusCode, Data, StatusMessage } = res;
        //   const { dispatch } = this.props;
        if (StatusCode === 401) {
          // logout(dispatch);
        }
        if (StatusCode === "Success") {
          //updaing data element with new returned data from service
          let _data = [...data];
          let _returnedItem = _data.findIndex((item) => item.ID === Data.ID);
          _data[_returnedItem] = Data;

          this.setState({
            isEditMode: false,
            selectedEntity: null,
            data: _data,
            isUpdatingTree: false,
            Text: "",
          });
        } else {
          this.setState({
            isUpdatingTree: false,
            Text: "",
          });
          addToast.error(StatusMessage, {
            toastId: "get-functions-error",
          });
        }
      })
      .catch((error) => {
        this.setState({
          isUpdatingTree: false,
          TextText: "",
        });
        addToast.error(error.message, {
          toastId: "get-functions-error",
        });
      });
  }

  deleteEntity() {
    const { selectedEntity, data } = this.state;
    if (selectedEntity) {
      this.setState({ isDeletingEntity: true });
      api.orgStructure
        .delete(selectedEntity.ID)
        .then((res) => {
          const { StatusCode, Data, StatusMessage } = res;
          // const { dispatch } = this.props;
          if (StatusCode === 401) {
            // logout(dispatch);
          }
          if (StatusCode === "Success" && Data !== false) {
            //moving element to root node before deletion to skip react unmount of non-child exception
            document
              .getElementById(this.rootNodeId)
              .appendChild(document.getElementById(`node${selectedEntity.ID}`));
            this.setState({
              showDeleteModal: false,
              isDeletingEntity: false,
              selectedEntity: null,
              data: data.filter((item) => item.ID !== selectedEntity.ID),
            });
          } else {
            this.setState({
              showDeleteModal: false,
              isDeletingEntity: false,
              selectedEntity: null,
            });
            addToast.error("toast.error");
          }
        })
        .catch((error) => {
          addToast.error(error.message, {
            toastId: "delete-function-error",
          });
          this.setState({
            showDeleteModal: false,
            isDeletingEntity: false,
            selectedEntity: null,
          });
        });
    }
  }

  //this will draw the structure of the tree elements
  drawTree() {
    let list = document.getElementById(this.rootNodeId).childNodes;

    //looping through rendered nodes and injecting each node under it's parent, skipping root nodes
    list.forEach((element) => {
      const parentId = element.getAttribute("data-parent-id");
      if (parentId !== this.rootNodeId) {
        document.getElementById(parentId).appendChild(element);
      }
    });

    //recurse the function drawTree while the rootNode has more than 1 element and the element has parent
    if (list.length > 1) {
      list.forEach((element) => {
        if (element.getAttribute("data-parent-id") !== this.rootNodeId) {
          this.drawTree();
        }
      });
    }
  }

  //this will handle tree margins by calculating parents and shifting every nested child under the parent element
  setTreeSpacing() {
    const { data } = this.state;
    data.forEach((element) => {
      let counter = 1;
      let childElement = document.getElementById(`node${element.ID}`);
      let currentParentElement = childElement.parentNode;

      while (currentParentElement.id !== this.rootNodeId) {
        currentParentElement = currentParentElement.parentNode;
        counter++;
      }
      //handling dynamic margin of each item-details element in tree-item
      //entity display mode
      childElement.querySelector(
        ".item-details .new-tree-item"
      ).style.marginInlineEnd = counter * 24 + "px";
      //entity edit mode
      childElement.querySelectorAll(
        ".item-details .edit-inputs"
      )[0].style.marginInlineStart = counter * 24 + 45 + "px";
      //entity add mode
      childElement.querySelectorAll(
        ".item-details .edit-inputs"
      )[1].style.marginInlineStart = counter * 24 + 69 + "px";
    });
  }

  componentDidMount() {
    this.getAllFunctions();
    this.getAllUsers();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data) {
      this.drawTree();
      this.setTreeSpacing();
    }
  }
  searchTree(searchedFilter) {
    const { originData } = this.state;
    const newData = SearchTree(originData, searchedFilter);
    this.setState({ loading: true, isFilterloading: true }, () => {
      let parentList = newData.filter((item) => item.ParentID === null);
      let othersList = newData.filter((item) => item.ParentID !== null);
      let TreeList = uniqBy(
        [
          ...recursiveList(othersList, originData),
          ...recursiveParent(parentList, originData),
        ],
        "ID"
      );
      TreeList.sort(function (a, b) {
        var nameA = a.ParentID;
        var nameB = b.ParentID;
        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        } else return 0;
      });
      this.setState({ data: TreeList, loading: false }, () => {
        this.drawTree();
        this.setTreeSpacing();
      });
    });
  }

  render() {
    const {
      data,
      loading,
      showDeleteModal,
      isDeletingEntity,
      isUpdatingTree,
      isEditMode,
      selectedEntity,
      isAddMode,
      searchedFilter,
      isFilterloading,
      users,
      usersLoading,
    } = this.state;
    return (
      <AdminPage
        title={<FormattedMessage id="common.organizational-structure" />}
        loading={loading}
      >
        <div className="tree-container">
          <>
            <div className={`${isFilterloading ? "" : " animated fadeInLeft"}`}>
              <div className="tr-header-container">
                <div
                  className="header-title"
                  style={{ color: "var(--primary-color)" }}
                ></div>
                <div className="tr-search-container">
                  <div>
                    <Search
                      requireSubmit
                      value={searchedFilter}
                      onChange={(searchedFilter) =>
                        this.setState({ searchedFilter }, () => {
                          this.searchTree(searchedFilter);
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="tree-body">
                <div className="tree-header">
                  <div className="header-child-1">
                    <FormattedMessage id="common.add" />
                  </div>
                  <div className="header-child-2">
                    <FormattedMessage id="common.operations" />
                  </div>
                </div>
                <div
                  id={this.rootNodeId}
                  onDrop={(event) => this.dropHandler(event)}
                  onDragOver={(event) => this.dragEnterHandler(event)}
                  onDragLeave={(event) => this.dragLeaveHandler(event)}
                  className="tree-item"
                >
                  {[
                    data.map((item) => (
                      <TreeItem
                        data={item}
                        users={users}
                        usersLoading={usersLoading}
                        key={item.ID}
                        isUpdatingTree={isUpdatingTree}
                        editMode={isEditMode}
                        isAddMode={isAddMode}
                        isSelected={
                          !!selectedEntity && selectedEntity.ID === item.ID
                        }
                        isAllowedToDelete={item.IsDeletable}
                        selectedEntity={selectedEntity}
                        dragLeaveHandler={(event) =>
                          this.dragLeaveHandler(event)
                        }
                        dragHandler={(event) => this.dragHandler(event)}
                        dropHandler={(event) => this.dropHandler(event)}
                        dragOverHandler={(event) =>
                          this.dragEnterHandler(event)
                        }
                        deleteEntityHandler={() =>
                          this.selectEntity(item, "delete")
                        }
                        editEntityHandler={() =>
                          this.selectEntity(item, "edit")
                        }
                        addEntityHandler={() => this.selectEntity(item, "add")}
                        cancelEntityHandler={() =>
                          this.setState({
                            isEditMode: false,
                            isAddMode: false,
                            selectedEntity: null,
                          })
                        }
                        saveEntityHandler={(_entity) =>
                          isAddMode
                            ? this.addNewEntity(_entity)
                            : this.saveEntity(_entity)
                        }
                      />
                    )),
                  ]}

                  {isAddMode && !selectedEntity.ID ? (
                    <TreeItem
                      data={[]}
                      users={users}
                      usersLoading={usersLoading}
                      key="newNode"
                      isUpdatingTree={isUpdatingTree}
                      isAddMode={true}
                      isAddRootNode={true}
                      isEditMode={false}
                      isSelected={true}
                      selectedEntity={selectedEntity}
                      cancelEntityHandler={() =>
                        this.setState({
                          isAddMode: false,
                          selectedEntity: null,
                        })
                      }
                      saveEntityHandler={(_entity) =>
                        isAddMode
                          ? this.addNewEntity(_entity)
                          : this.saveEntity(_entity)
                      }
                    />
                  ) : null}
                </div>
                <Row justify="center" className="d-flex tree-footer">
                  <Button
                    varient="secondary"
                    disabled={isEditMode || isAddMode}
                    style={{
                      padding: "8px 16px",
                    }}
                    onClick={() =>
                      this.selectEntity(null, this.entityActions.addRoot)
                    }
                  >
                    <FormattedMessage id="org-structure.add" />
                  </Button>
                </Row>
                {isUpdatingTree ? <div className="ui-block"></div> : null}
              </div>
            </div>
          </>
          {showDeleteModal ? (
            <DeleteModal
              isOpen={showDeleteModal}
              title={<FormattedMessage id="org-structure.entity" />}
              closeModal={() => this.setState({ showDeleteModal: false })}
              handleDelete={() => this.deleteEntity()}
              ButtonStatus={isDeletingEntity}
            />
          ) : null}
        </div>
      </AdminPage>
    );
  }
}

export default Tree;
